import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-hex-privacy-policy',
  templateUrl: './hex-privacy-policy.component.html',
  styleUrls: ['./hex-privacy-policy.component.css']
})
export class HexPrivacyPolicyComponent implements OnInit {

  constructor(private title: Title) {
    title.setTitle("Privacy Policy");
  }

  ngOnInit(): void {
  }

}
